export enum TabState {
  ENGINE_RUNNING,
  NOT_RUN,
  LOADING,
  EMPTY,
  COMPLETE,
  FAILED,
}
